import React from 'react'
import PropTypes from "prop-types";
import {connect} from "react-redux";
import * as Cookies from "js-cookie";
import UserHeader from '../Parts/Header/Header-User';
import GuestHeader from '../Parts/Header/Header-Guest';
import socket from "../../../Socket";
import {Event, decode, encode, wait, isMobile} from "../../../Helper";
import WalletAlert from "../../Components/User/Wallet/Alert";
import C from "../../../Constant";
import Login from "../Auth/Login";
import storage from "../../../Storage";
import Engine from "../../Games/Crash/Engine";
import Mobi from "../../Games/Crash/Graphic/Mobi";
import { useParams } from 'react-router-dom';
import {Link} from "react-router-dom";
import Footer from "../Parts/Footer";
class Aviator extends React.Component {
    _Mounted = false;
    constructor(props){
        
        super(props);
        // console.log("params"+JSON.stringify(this.props))
        // const { game_name, category } = this.props.match.params;
        this.state = {
            mobile:false,
            showBackToTop: false,
            isLogged: false,
            token: false,
            header: <GuestHeader t={this.props.t} location={this.props.location} tab='aviator' />,
            footer: <Footer t={this.props.t} location={this.props.location} />,
            auth: false
        }
        this.handleResize = this.handleResize.bind(this);
    }
    componentWillMount() {
        wait(500).then(() => {
            this._Mounted = true;
        })
    }

    componentDidMount(){
        socket.on(C.ONLINE, (status) => this.loginUser(decode(status)));
         Event.on('showAuthModal', (status) => this.activeAuth(status));

        let path = window.location.pathname;
        // console.log("Auth modal show")
        
        // console.log("game id: " + path)
        /**
         * Initialize Authentication
         */
        const sessionCookie = Cookies.get("auth");

        if(storage.getKey('token') !== null && sessionCookie)
        {
            socket.emit(C.ONLINE, encode({
                jwt_token: storage.getKey('jwt_token'), //fake
                user_token: storage.getKey('user_token'), //fake
                security_key: storage.getKey('security_key'), //fake
                secret_user: storage.getKey('secret_user'), //fake
                secret_realtime: storage.getKey('secret_realtime'), //fake
                client_system: storage.getKey('client_system'), //fake
                token_key: storage.getKey('token_key'), //fake
                secret_token: storage.getKey('secret_token'), //fake
                token: storage.getKey('token'), // REAL
            }));
        }
        wait(2000).then(() => {
            this.handleResize();
           if(!this.isLogged){
            Event.emit('showAuthModal')
            }
        });
        window.addEventListener('resize', this.handleResize);
        //         let scrollX = window.scrollX;
        // let scrollY = window.scrollY;

        // window.addEventListener("scroll", () => {
        // window.scrollTo(scrollX, scrollY);
        // });


        // ✅ Add this
    window.addEventListener("scroll", this.handleScroll);
        this.loadGames()
        wait(500).then(() => {
            Engine.getStatus();
        });
    }
    handleScroll = () => {
    if (window.scrollY > 20) {
        this.setState({ showBackToTop: true });
    } else {
        this.setState({ showBackToTop: false });
    }
    };

    scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    };
    activeAuth = (status) => {
        this.setState({ auth: status });
    }

    loadGames = () => {
        const token = storage.getKey('token')
        const gameCategory = this.state.game_category;
        const gameName = this.state.game_name;
        const portalName = "jamobets";
        const lang = "en";
        const returnUrl = "jamobets.co.ke";
        const url = `https://aviator-next.spribegaming.live/?operator=jamobets&token=${token}&lang=EN&currency=KES&return_url=https://jamobets.com`;
        
        this.setState({game_url: url})
        this.setState({stp_game: true})
        return ""

    }

    loginUser = (data) => {
        wait(500).then(() => {
            // console.log('Log in user data', data)
            if(data.status === true)
            {
                this.setState({ isLogged: true, token: storage.getKey('token') });
                this.setState({ header: <UserHeader t={this.props.t} location={this.props.location} tab='aviator' /> });
                Cookies.set("uid", data.id, {expires: 14});
                Cookies.set("auth", true, {expires: 14});
                // storage.setKey('name', data.name);
                // storage.setKey('email', data.email);
                // storage.setKey('phoneNumber', data.phoneNumber);
                // storage.setKey('credit', data.credit);
                // storage.setKey('avatar', data.avatar);
                // storage.setKey('friends', data.friends);
                // storage.setKey('room', data.room);
            }
            else {
                wait(100).then(() => {
                    localStorage.clear();
                })
            }
        })
    }
    getWidth(){
        return document.documentElement.clientWidth || document.body.clientWidth;
    }
    handleResize(){
        if(this.getWidth() < 1540)
        {
            this.setState({ col: 'col-xl-12'});
            Event.emit('hide_games');
        }
        else {
            this.setState({ col: 'col-xl-9'});
            Event.emit('show_min_games');
        }

        if(isMobile()){

            this.setState({ mobile: true });
        }
        else {
            this.setState({ mobile: false });
        }

        if(isMobile()){
            this.setState({ padding: 'p-0', ovh: 'ovh' });
        }
    }
    
     render(){
        // const { game_name, category } = useParams();
        let { header, auth, mobile, games, stp_game, footer, showBackToTop } = this.state;
        let { content } = this.props; // Pages / Game Contents
        let wallet; // Show Wallet if User don't Have Cash
        let { game } = this.props;
        try {
            wallet = this.props.get_wallet.show;
        }
        catch (e) {}

        const engine = Engine;

        const { t } = this.props;
        // const stp = await this.loadGames()
        // console.log("render: "+ JSON.stringify(stp_game))
        // const list = stp_game?.map((row, i) =>
        //     <List key={i} row={row} />
        // );
         if(stp_game){


        return(
            <>
 <div className="page-wrapper">
                
                <div className="page-content container py-1 px-1" id={'page-content'}>
                        {header}
                        {showBackToTop && (
  <button
    onClick={this.scrollToTop}
    style={{
      position: "fixed",
      bottom: "30px",
      right: "30px",
      zIndex: 1000,
      backgroundColor: "#223A59",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      padding: "12px 16px",
      cursor: "pointer",
      boxShadow: "0 4px 6px rgba(0,0,0,0.2)"
    }}
  >
    <i class="mdi mdi-arrow-up"></i>
  </button>
)}
                        <iframe sandbox tabindex="-1" className='jetx-iframe' src={this.state.game_url}  allowFullScreen={true}
        ></iframe>
                        
                        {/*<>*/}
                        {/*    {list?.length === 0 ?*/}
                        {/*        <>*/}
                        {/*            You have not introduced anyone yet*/}
                        {/*        </>*/}
                        {/*        :*/}
                        {/*        <div className={'games-section sss'}>*/}
                        {/*            {list}*/}
                        {/*        </div>*/}

                        {/*    }*/}
                        {/*</>*/}
                        {/*<iframe src={stp_game} >*/}

                        {/*</iframe>*/}
                        {/* {footer} */}
                    </div>
                    </div>

            </>

        );

         }else{
             return (<></>)
         }
    }
}

class List extends React.Component {

    render(){
        let { row } = this.props;
        return (
            <div className={'game-card'}>
                <span >
                </span>
            </div>
        );
    }
}

Aviator.propTypes = {
    get_wallet: PropTypes.string
};

const mapStateToProps = state => ({
    get_wallet: state.items.get_wallet
});

export default connect(mapStateToProps, null)(Aviator);